module.exports = __webpack_public_path__ + "img/AdvancedPowerArmor.aa5957aa.gif";